/* eslint-disable jsx-a11y/anchor-is-valid */

/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Grid, Typography } from '@material-ui/core';

import * as session from '../../../../utils/session';
import ROUTES_NAME from '../../../../consts/routes-name';
import HOME from '../../../../consts/text/home';
import { CardLogin } from '../../CardLogin';
import { useStyles } from '../../styles';

function CardLoginForm({ isNaoCorrentista = false, gtm }) {
  const classes = useStyles({ isNaoCorrentista });
  const isChatbot = session.getChatbot();
  const navigate = useNavigate();

  const tagIdEsqueciSenha = isChatbot
    ? 'esqueci-senha-whats-001'
    : 'esqueci-senha-001';
  const tagIdPrimeiroAcesso = isChatbot
    ? 'primeiro-acesso-whats-001'
    : 'primeiro-acesso-001';

  return (
    <Grid item container alignItems="center" direction="column" spacing={2}>
      <CardLogin
        gtm={gtm}
        isNaoCorrentista={isNaoCorrentista}
        tagIdEsqueciSenha={tagIdEsqueciSenha}
      />
      <Typography
        component="a"
        className={classes.link}
        onClick={() => navigate(ROUTES_NAME.PRIMEIRO_ACESSO)}
        data-gtm-type="click"
        data-gtm-clicktype="button"
        id={tagIdPrimeiroAcesso}
        data-gtm-name="primeiro-acesso"
      >
        {HOME.PRIMEIRO_ACESSO}
      </Typography>
    </Grid>
  );
}

export default CardLoginForm;
